import * as urlUtils from 'utils/Url';


export function getPathControlConnections(qs={}) {
  return urlUtils.appendQueryString(`/control/connections`, qs);
}
